var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCh4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:currentColor;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1_8 Channel 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,100l4.55-5.94c15-19.65,57-72.08,62.18-80.12C73.11,4,84,0,86.92,0h47.87C172.78,14.44,200,53.43,200,99.26c0,47.5-29.25,87.65-69.41,100.74H86.92c-2.59,0-13.81-4-20.19-13.94-5.15-8-47-60.26-62.09-80Zm116.68,43.66a7.34,7.34,0,0,0,5.74,2.45,7.44,7.44,0,0,0,5.78-2.38q2.16-2.39,2.16-7.27V124.65h3.87q4.83,0,7.24-1.68a6.09,6.09,0,0,0,2.41-5.36c0-3-1-5-2.95-5.84a19.26,19.26,0,0,0-7.84-1.34h-2.73V61.3q0-11-9.65-11a7.21,7.21,0,0,0-5.11,2,50.88,50.88,0,0,0-5.43,6.44l-33.64,45c-.93,1.22-1.71,2.26-2.35,3.11s-1.25,1.72-1.84,2.63a12.58,12.58,0,0,0-1.33,2.6,7.15,7.15,0,0,0-.45,2.45,9.51,9.51,0,0,0,3,7.42q3,2.73,9,2.73h31.87v11.81C114.49,139.63,115.22,142,116.68,143.66Zm-2.19-70.11v36.88H87.19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCh4);
export default __webpack_public_path__ + "static/media/Ch4.35e324db25b4f2104e929687e3300e73.svg";
export { ForwardRef as ReactComponent };